// File: src/components/common/StyledContentContainer.js
// -----------------------------------------------------
import React from 'react';
import { CardContent } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Styled content container component
 */
const StyledContentContainer = ({ children, ...props }) => (
  <CardContent
    sx={{
      p: 2,
      pt: 1.5,
      pb: '8px !important', // override material UI default
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      ...props.sx
    }}
    {...props}
  >
    {children}
  </CardContent>
);

StyledContentContainer.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};

export default StyledContentContainer;